import { useTranslation } from 'react-i18next';

export default function Tab5({ dcDpo }) {
    const { t } = useTranslation();

    return (
        <div className="grid grid-cols-3 gap-4 mt-4">
            <div className="col-span-2 p-4 box-content">
                <div className="text-lg font-semibold text-purple mb-1">
                    {t('RoPA.DataController')}
                </div>
                <p className="mb-0 whitespace-pre-wrap">
                    {dcDpo?.nameTh || '-'}
                </p>
            </div>
            <div className="col-span-2 p-4 box-content">
                <div className="text-lg font-semibold text-purple mb-1">
                    {t('Address')}
                </div>
                <p className="mb-0 whitespace-pre-wrap">{dcDpo?.addressTh}</p>
            </div>
            <div className="col-span-2 p-4 box-content">
                <div className="text-lg font-semibold text-purple mb-1">
                    {t('dcdpo.Contact')}
                </div>
                <p className="mb-0 whitespace-pre-wrap">{dcDpo?.contractTh}</p>
            </div>
        </div>
    );
}
